<template>
<div class="box-view" :class="{

left: transition === 'left-to-right',

right: transition === 'right-to-left'

  }" ref="box">
    <!-- HEADER DÙNG CHUNG -->
    <header class="bg-primary text-white py-3 mb-0 position-relative">
        <div class="container d-flex align-items-center justify-content-between">

            <!-- NÚT BACK -->
            <span v-if="showBack" class="back-btn text-white" @click="close">
                <i class="fas fa-arrow-left fa-lg"></i>
            </span>

            <!-- Title -->
            <h2 class="mb-0 font-weight-bold text-center flex-grow-1">
                {{ title }}
            </h2>

            <!-- Quick Sales Button -->
            <button v-if="$route.path !== '/'" class="btn btn-link text-white p-0 mx-2 ml-auto" @click="$router.push('/')" title="Về màn hình bán hàng">
                <i class="fas fa-shopping-cart fa-lg"></i>
            </button>

            <!-- Notification Bell -->
            <notification-bell :count="unreadNotiCount" :class="{ 'ml-auto': $route.path === '/' }" class="mx-2" />

            <!-- Menu button -->
            <button class="btn btn-link text-white p-0 ml-3" @click="showMenu = !showMenu">
                <i class="fas fa-bars fa-2x"></i>
            </button>

            <!-- Dropdown -->
            <div v-if="showMenu" class="menu-dropdown shadow">
                <div class="menu-header d-flex align-items-center p-3 border-bottom">
                    <img :src="user.avatar" class="rounded-circle mr-2" width="40" height="40" alt="avatar" />
                    <div>
                        <div class="font-weight-bold">{{ user.name }}</div>
                        <div class="small text-muted">{{ displayRole }}</div>
                    </div>
                </div>

                <ul class="list-unstyled mb-0">
                    <li v-for="(item, index) in filteredMenus" :key="item.name">
                        <a href="#" class="dropdown-item" @click.prevent="go(item.name)">
                            <i :class="item.icon" class="mr-2"></i> {{ item.title }}
                        </a>
                        <hr v-if="index < filteredMenus.length - 1" class="my-1" />
                    </li>
                    
                    <li><hr class="my-1" /></li>
                    <li>
                        <a href="#" class="dropdown-item text-danger" @click="logout">
                            <i class="fas fa-sign-out-alt mr-2"></i> Thoát tài khoản
                        </a>
                    </li>
                </ul>
            </div>

        </div>
    </header>

    <!-- BODY -->
    <div class="box-body">
        <slot></slot>
    </div>
</div>
</template>

<script>
import NotificationBell from './notifications/NotificationBell.vue';

export default {
    components: {
        NotificationBell
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        transition: {
            type: String,
            default: ''
        },
        touch: {
            type: Boolean,
            default: false
        },
		showBack: {
			type: Boolean,
			default: true // mặc định CÓ nút back
		}
    },

    data() {
        return {
            showMenu: false,
            app: this.$root.getApp()
        }
    },
    computed: {
        user() {
            // Get user from App.vue instance if available
            if (this.app && this.app.viewCurrentUser) {
                const u = this.app.viewCurrentUser;
                return {
                    id: u.id,
                    avatar: u.avatar || 'https://i.pravatar.cc/100',
                    name: u.full_name || u.name || 'Admin',
                    role: u.role || 'staff'
                };
            }
            return { id: null, avatar: 'https://i.pravatar.cc/100', name: 'Nguyễn Văn A', role: 'staff' };
        },
        displayRole() {
            return this.mapRole(this.user.role);
        },
        filteredMenus() {
            const allPossibleMenus = [
                { name: 'home', title: 'Bán hàng (POS)', icon: 'fas fa-cash-register' },
                { name: 'temporaryorder', title: 'Đơn tạm', icon: 'fas fa-pause-circle' },
                { name: 'orderhistory', title: 'Lịch sử đơn', icon: 'fas fa-history' },
                { name: 'admin', title: 'Quản lý phần mềm', icon: 'fas fa-chart-line' },
                { name: 'revenuereport', title: 'Báo cáo doanh thu', icon: 'fas fa-chart-bar' },
                { name: 'productlist', title: 'Sản phẩm', icon: 'fas fa-boxes' },
                { name: 'category', title: 'Danh mục', icon: 'fas fa-tags' },
                { name: 'debt', title: 'Công nợ', icon: 'fas fa-file-invoice-dollar' },
                { name: 'transaction', title: 'Thu chi', icon: 'fas fa-exchange-alt' },
                { name: 'supplier', title: 'Nhà cung cấp', icon: 'fas fa-truck' },
                { name: 'customer', title: 'Khách hàng', icon: 'fas fa-user-friends' },
                { name: 'user', title: 'Nhân viên', icon: 'fas fa-users-cog' },
                { name: 'printedbills', title: 'Lịch sử in Bill', icon: 'fas fa-receipt' },
                { name: 'notifications', title: 'Thông báo', icon: 'fas fa-bell' },
                { name: 'settings', title: 'Cấu hình hệ thống', icon: 'fas fa-cog' },
                { name: 'account', title: 'Cá nhân', icon: 'fas fa-user-circle' }
            ];

            if (!this.app || !this.app.settings || !this.app.settings.user || !this.app.settings.user.roles) {
                // Fallback to basic menus if settings not loaded
                return allPossibleMenus.filter(m => ['home', 'orderhistory', 'account'].includes(m.name));
            }

            const roleConfig = this.app.settings.user.roles[this.user.role];
            if (!roleConfig || !roleConfig.menus) return [];

            return allPossibleMenus.filter(menu => roleConfig.menus.includes(menu.name) || menu.name === 'account');
        },
        unreadNotiCount() {
            return this.$root.unreadNotiCount || 0;
        }
    },

    methods: {
        close() {
            this.$emit('close')
        },
        mapRole(role) {
            const maps = {
                'admin': 'Quản trị viên',
                'staff': 'Nhân viên bán hàng',
                'accountant': 'Kế toán'
            };
            return maps[role] || role || 'Nhân viên';
        },

        go(name) {
            this.showMenu = false
            this.$router.push({
                name
            })
        },

        logout() {
            this.showMenu = false
            if (this.app) {
                this.app.handleLogout();
            }
        }
    },

    mounted() {
        const box = this.$refs.box
        $(box)
            .find('.box-body')
            .on('scroll', () => {
                $(window).trigger('scroll')
            })
    }
}
</script>
